module.exports = __webpack_public_path__ + "img/gartek-services-plan-review-inspections.cd4aa80e.jpeg";